<article class="card">
  <div class="content-preview" [ngSwitch]="post.type">
    <ng-container *ngIf="post.poll">
      <app-vk-poll *ngSwitchCase="'poll'" [answers]="post.poll.answers" [isFinished]="post.poll.isFinished"></app-vk-poll>
    </ng-container>

    <img [src]="post.imagePath" alt="Пост VK" class="image" *ngSwitchCase="'photo'" />

    <a class="video-thumbnail" *ngSwitchCase="'video'" [href]="vkGroupLinkWall + post.postId" target="_blank">
      <svg [icon]="icons.VideoPlay" class="video-play-icon"></svg>
      <img [src]="post.imagePath" alt="Пост VK" class="image" />
    </a>

    <img src="/assets/img/no-post-pic.png" alt="Пост VK" class="image" *ngSwitchCase="'text'" />
    <img src="/assets/img/vk-file-pic.png" alt="Пост VK" class="image" *ngSwitchCase="'file'" />
    <img src="/assets/img/vk-audio-pic.png" alt="Пост VK" class="image" *ngSwitchCase="'audio'" />

    <a class="link-thumbnail" *ngSwitchCase="'link'" [href]="vkGroupLinkWall + post.postId" target="_blank">
      <img [src]="post.imagePath" alt="Пост VK" class="image" />
      <span class="link-thumbnail-filter"></span>
      <h3 class="h2 link-title">{{ post.title }}</h3>
    </a>

    <ng-container *ngIf="post.map">
      <app-map *ngSwitchCase="'map'" [mapGeoData]="post.map" [mapElementId]="post.text + post.likesCount"></app-map>
    </ng-container>
  </div>

  <div class="info">
    <div *ngLet="onLangChange$ | async" class="caption-4 mb8">
      {{ post.createData | date: 'dd MMMM HH:mm':undefined:locale }}
    </div>

    <a
      *ngIf="['video', 'poll', 'audio', 'map', 'file', 'link'].includes(post.type)"
      #title [toolTipWidth]="titleWidth" [customToolTip]="post.title ?? ''"
      [href]="vkGroupLinkWall + post.postId"
      class="link-4"
      target="_blank"
      >{{ post.title }}</a>

    <p #text [toolTipWidth]="textWidth" [customToolTip]="post.text" class="body-2 description" [ngClass]="{'one-row':title}" *ngIf="post.type !== 'poll'; else pollDescription">{{ post.text }}</p>

    <div class="icons-wrapper mt12">
      <svg *ngIf="post.isPinned" [icon]="icons.Pinned" class="svg22 mr12 inactive-color" />
      <svg [icon]="icons.Comment" class="svg24 inactive-color" />
      <span class="inactive-color mr12">{{ post.commentsCount }}</span>
      <svg [icon]="icons.Like" class="svg24 inactive-color" />
      <span class="inactive-color">{{ post.likesCount }}</span>
    </div>

    <div class="footer">
      <a class="btn-secondary small td-n" [href]="vkGroupLinkWall + post.postId" target="_blank">
        {{ post.type | postBtnText : post.poll?.isFinished  ?? false | translate }}
      </a>
    </div>
  </div>
</article>

<ng-template #pollDescription>
  <div>
    <span class="body-2 mr12 marker">Публичный опрос</span>
    <span class="body-2" [style.color]="post.poll?.isFinished ? 'var(--positive-color)' : 'var(--primary-60-color'">{{
      post.poll?.isFinished ? 'Завершен' : 'Активен'
    }}</span>
  </div>
</ng-template>
